import apiClient from "@/shared/api/apiClient2";

export const signParticipant = async (transaction_id, params) => {
  const result = await apiClient.post(
    `/signatures/${transaction_id}/sign-participant`,
    {
      ...params,
    }
  );
  return result.data;
};

export const signatureValidate = async (signature_uuid) => {
  const result = await apiClient.post(
    `/signatures/validate/${signature_uuid}`,
    undefined,
    { metaData: { isNotificationDisabled: true } }
  );
  return result.data;
};

export const getSignatureList = async (transaction_id) => {
  const result = await apiClient.get(`/signatures/${transaction_id}`);
  return result.data;
};

export const getCurrentSignParticipant = async (transaction_id) => {
  const result = await apiClient.get(
    `/signatures/${transaction_id}/current-signer`
  );
  return result.data;
};
